'use strict';

var React = require('react');

var SvgOrderDraftFilledIcon = function SvgOrderDraftFilledIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M6.976 5c-.62 0-1.146.454-1.237 1.067l-.583 3.933h2.484c.538 0 1.015.344 1.185.855l.159.474c.034.102.13.171.237.171h1.558c.108 0 .203-.069.237-.171l.159-.474c.17-.51.647-.855 1.185-.855h2.484l-.086-.578c-.06-.41.222-.79.632-.851.41-.061.791.222.852.632l.163 1.104c.063.425.095.853.095 1.282v1.661c0 1.795-1.455 3.25-3.25 3.25h-6.5c-1.795 0-3.25-1.455-3.25-3.25v-1.66c0-.43.032-.858.094-1.283l.661-4.46c.2-1.348 1.357-2.347 2.72-2.347h3.775c.414 0 .75.336.75.75s-.336.75-.75.75h-3.774Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.454 2.354c-.195-.196-.512-.196-.707 0l-.957.957 1.768 1.767.957-.957c.195-.195.195-.512 0-.707l-1.06-1.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.85 5.786-1.767-1.768-2.83 2.83c-.36.36-.569.841-.585 1.348l-.026.772c-.005.145.114.263.258.258l.772-.025c.507-.017.99-.226 1.348-.585l2.83-2.83Z"
  }));
};
SvgOrderDraftFilledIcon.displayName = "OrderDraftFilledIcon";

exports.SvgOrderDraftFilledIcon = SvgOrderDraftFilledIcon;
